import moment from "moment";
import { NepaliCalendar } from "nepali-calander";
import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import "../../../assets/scss/calendarWidget.scss";
import { getCalendarEvents } from "../../../ducks/AcademicAdministrationDucks";
import { axiosGetUnAuth, axiosPost } from "../../../utils/AxiosApi";
import {
  URL,
  checkForSubRoles,
  draggable,
  userRole,
  userRoleCode,
} from "../../../utils/Constants";
import {
  displayConfirmDeleteAlert,
  displayErrorAlert,
  displayMessage,
} from "../../../utils/Utils";
import ModalWindow from "../../UI/ModalWindow";
import CalendarForm from "./CalendarForm";
import CalendarWidgetHeader from "./CalendarWidgetHeader";
// const { adToBs } = require('@sbmdkl/nepali-date-converter');
const { adToBs, bsToAd } = require("meropatro-dateconverter");

class CalendarWidget extends Component {
  calendarComponentRef = React.createRef();
  state = {
    modal: false,
    calendarTitle: "",
    startDate: "",
    endDate: "",
    description: "",
    action: "add",
    events: [],
    eventInfo: "",
    updateId: "",
    checked: false,
    error: "",
    //educationLevelId: "0",
    educationLevels: [],
    calendarDates: [],
    dates: [],
    educationLevelIdMultiple: "0",
    terms: [],
    termId: "0",
    eduLevelTitle: "All",
    termTitle: `All ${
      localStorage.getItem("educationLevelDivision")
        ? localStorage.getItem("educationLevelDivision")
        : "Terms"
    }`,
    selectedItems: null,
    widgetEvents: [],
    currentAcYrId: "",
    currentAcYr: "",
    currentAcYrName: "",
    assessmentModules: [],
    eventNameError: false,
    holidaysOption: [],
    selectHolidayOption: [],
    colorCode: "",
    isHoliday: false,
    selectedEvent: "",
    eventType: "",
    infoDate: null,
    calendarLoading: true,
    newCalendarDates: null,
    newCalendarOtherData: null,
    adCalendar: false,
    bsCalendar: true,
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ calendarLoading: false });
    }, 2000);
    this.getEducationLevel();
    this.getWidgetEvents();
    axiosPost(
      URL.getAssesmentModuleAndEducationLevelForCurrentUser,
      {},
      (response) => {
        if (response.status === 200) {
          this.setState({
            assessmentModuleandEducationLevel: response.data.data,
          });
        }
      },
    );
    this.getUserCurrentAcademicYear();
    this.getAssessmentModules();
    this.getHolidays();
  }

  //calender Events
  getHolidays = () => {
    axiosPost(URL.getHolidayOptions, {}, (response) => {
      if (response.data.status === 200) {
        const data = response.data.data;
        if (data.length > 0)
          this.setState({
            holidaysOption: data,
          });
        const selectOptions = this.state.holidaysOption.map((el) => {
          return {
            value: el.id,
            label: el.eventTypeName,
            color: el.colorCode,
          };
        });
        this.setState({ selectHolidayOption: selectOptions });
      }
    });
  };

  getAssessmentModules = () => {
    axiosPost(URL.getAssesmentModules, {}, (response) => {
      if (response.status === 200) {
        this.setState({ assessmentModules: response.data.data });
      }
    });
  };

  getUserCurrentAcademicYear = () => {
    axiosPost(URL.selectUserAcademicYear, {}, (response) => {
      if (response.status === 200) {
        if (response.data.data) {
          this.setState(
            {
              currentAcYr: response.data.data,
              currentAcYrId: response.data.data.academicYearId,
              currentAcYrName: response.data.data.academicYearName,
            },
            function () {
              // this.getAcYrDate();
            },
          );
        } else {
          this.getCurrentAcademicYear();
        }
      }
    });
  };

  getCurrentAcademicYear = () => {
    let data = {
      isCurrent: "true",
    };

    axiosPost(URL.getAcademicYears, data, (response) => {
      if (response.status === 200) {
        this.setState(
          {
            currentAcYr: response.data.data[0],
            currentAcYrId: response.data.data[0].id,
            currentAcYrName: response.data.data[0].name,
          },
          function () {
            // this.getAcYrDate();
          },
        );
      }
    });
  };

  getWidgetEvents = () => {
    this.setState({ calendarLoading: true });
    axiosPost(URL.getEvents, {}, async (responseWidgets) => {
      if (responseWidgets.status === 200) {
        axiosPost(URL.getWeekDaysByEduDiv, {}, (response) => {
          if (response.status === 200) {
            let newEvents = [...responseWidgets.data.data];

            this.setState({
              unfilteredEvents: newEvents,
            });

            newEvents.forEach((event) => {
              event.end = moment(event.end).format("YYYY-MM-DD");
              event.start = moment(event.start).format("YYYY-MM-DD");
            });
            this.setState(
              {
                widgetEvents: [...newEvents],
              },
              () => {
                const events = [...this.state.widgetEvents];
                const unique = [];
                events.map((x) =>
                  unique.filter(
                    (a) =>
                      a.color == x.color &&
                      a.title == x.title &&
                      a.start == x.start &&
                      a.end == x.end,
                  ).length > 0
                    ? null
                    : unique.push(x),
                );
                this.setState({ uniqueCalendarEvents: unique });
              },
            );
          }
        });
        this.setState({ calendarLoading: false });
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    ReactTooltip.rebuild();
  }

  //Axios Get request to get values from the database
  // getAllDates = () => {
  //   let newDates = [...this.state.dates];
  //   for (let i = 1; i <= 12; i++) {
  //     if (i < 10) {
  //       newDates.push("0" + i.toString());
  //     } else {
  //       newDates.push(i.toString());
  //     }
  //   }
  //   this.setState({ dates: newDates });
  // };

  getEducationLevel = () => {
    axiosPost(URL.getEducationLevel, {}, (response) => {
      if (response.status === 200) {
        this.setState({ educationLevels: response.data.data });
        let selectedItems = [...response.data.data];
        selectedItems.forEach((level) => {
          level.label = level.name;
          level.value = level.id;
        });
        this.setState({ selectedItems });
      }
    });
  };

  getData = (color, isHoliday, eventTypeName, educationLevelId) => {
    let newEl = [];

    if (this.state.educationLevelIdMultiple === "0") {
      newEl = this.state.educationLevels.map((el) => {
        return el.id;
      });
    } else {
      newEl.push(this.state.educationLevelIdMultiple);
    }

    let param = [];

    if (this.state.action === "add") {
      param.push({
        title: this.state.calendarTitle,
        start: moment(this.state.startDate).format("YYYY-MM-DD"),
        end: moment(this.state.endDate).format("YYYY-MM-DD"),
        educationLevelIds: newEl,
        description: this.state.description
          ? this.state.description
          : "no description",
        color: color,
        isHoliday: isHoliday,
        eventTypeName: eventTypeName,
      });

      // if (this.state.action === "add") {
      //   param.push({
      //     title: this.state.calendarTitle,
      //     start: moment(this.state.startDate).format("YYYY-MM-DD"),
      //     end: moment(this.state.endDate).format("YYYY-MM-DD"),
      //     educationLevelId:
      //       parseInt(this.state.educationLevelIdMultiple) === 0
      //         ? this.state.selectedItems[0].id
      //         : parseInt(this.state.educationLevelIdMultiple),
      //     description: this.state.description
      //       ? this.state.description
      //       : "no description",
      //     color: color,
      //     isHoliday: isHoliday,
      //     eventTypeName: eventTypeName,
      //   });

      // this.state.selectedItems.forEach(item => {
      //   param.push({
      //     title: this.state.calendarTitle,
      //     start: moment(this.state.startDate).format("YYYY-MM-DD"),
      //     end: moment(this.state.endDate).format("YYYY-MM-DD"),
      //     educationLevelId:
      //       parseInt(this.state.educationLevelIdMultiple) === 0
      //         ? item.id
      //         : parseInt(this.state.educationLevelIdMultiple),
      //     description: this.state.description
      //       ? this.state.description
      //       : "no description",
      //     color: color,
      //     isHoliday: isHoliday,
      //     eventTypeName: eventTypeName
      //   });
      // });
    } else {
      param = {
        title: this.state.calendarTitle,
        start: moment(this.state.startDate).format("YYYY-MM-DD"),
        end: moment(this.state.endDate).format("YYYY-MM-DD"),
        // educationLevelIds: newEl,
        description: this.state.description
          ? this.state.description
          : "no description",
        color: color,
        isHoliday: isHoliday,
        eventTypeName: eventTypeName,
      };
    }
    return param;
  };

  renderNepaliDates = () => {
    const dates = document.querySelectorAll(".fc-day");
    // const currentDate = new Date();
    const currentDate = new Date(this.state?.infoDate?.view.currentStart);
    const currentMonth = currentDate?.getMonth();
    const currentYear = currentDate?.getFullYear();

    dates.forEach((date) => {
      const dateStr = date.getAttribute("data-date");
      const nepalTime = new Date(dateStr);
      const formattedDate = moment(nepalTime).format("YYYY-MM-DD");

      // const nepaliDate = moment(adToBs(formattedDate)).format("DD");
      const nepaliDate = adToBs(formattedDate).split("-")[2];

      // const nepaliDateDevanagari = nepaliDate.replace(/[0-9]/g, (match) => this.devanagariDigits[match]);
      const nepaliDateDevanagari = nepaliDate
        .split("")
        .map((digit) => this.devanagariDigits[digit])
        .join("");
      const existingDiv = date.querySelector("span");
      if (existingDiv) {
        existingDiv.remove();
      }
      const newDiv = document.createElement("span");
      newDiv.style.position = "absolute";
      newDiv.style.bottom = "0";
      newDiv.style.marginLeft = "2px";

      if (
        nepalTime?.getMonth() !== currentMonth ||
        nepalTime.getFullYear() !== currentYear
      ) {
        newDiv.style.opacity = "0.3";
      }

      newDiv.innerText = nepaliDateDevanagari;
      // added nepali font styles as nep dates appended was being replaced in browser by eng dates
      newDiv.style.cssText = `
      position: absolute;
      bottom: 0;
      marginLeft: 5px;
      font-family: 'NepaliFont', Arial;
      opacity: ${
        nepalTime?.getMonth() !== currentMonth ||
        nepalTime?.getFullYear() !== currentYear
          ? "0.3"
          : "1"
      };`;
      date.append(newDiv);
    });

    if (this.state.infoDate != null) {
      const currentDate = moment(
        new Date(this.state?.infoDate?.view.currentStart),
      ).format("YYYY-MM-DD");

      const currentDateEnd = moment(
        new Date(this.state?.infoDate?.view.currentEnd),
      ).format("YYYY-MM-DD");

      const nepaliDate = adToBs(currentDate);
      const nepaliDateEnd = adToBs(currentDateEnd);

      const nepaliMonth =
        this.nepaliMonths[moment(nepaliDate).format("MM") - 1];
      const nepaliMonthEnd =
        this.nepaliMonths[moment(nepaliDateEnd).format("MM") - 1];
      const nepaliMonthYearNp = `(${nepaliMonth}-${nepaliMonthEnd}, ${moment(
        nepaliDate,
      )
        .format("YYYY")
        .replace(/[0-9]/g, (match) => this.devanagariDigits[match])})`;

      // // Append the Nepali month and year to the header title
      const h2Header = document.getElementsByTagName("h2");
      const existingSpan = h2Header[1]?.querySelector("span");

      if (existingSpan) {
        existingSpan.remove();
      }

      const newSpan = document.createElement("span");
      newSpan.innerText = nepaliMonthYearNp;
      if (h2Header[1]) {
        h2Header[1].append(newSpan);
      }
    }

    //  insert day values in nepali
    let days = document.querySelectorAll(
      ".fc-day-header.fc-widget-header.fc-sun, .fc-day-header.fc-widget-header.fc-mon, .fc-day-header.fc-widget-header.fc-tue, .fc-day-header.fc-widget-header.fc-wed, .fc-day-header.fc-widget-header.fc-thu, .fc-day-header.fc-widget-header.fc-fri, .fc-day-header.fc-widget-header.fc-sat",
    );
    let nepaliDays = ["आइत", "सोम", "मंगल", "बुध", "बिही", "शुक्र", "शनि"];
    let secondWeekDays = Array.prototype.slice.call(days, 7);
    secondWeekDays.forEach((day, index) => {
      let nepaliDay = nepaliDays[index % 7];
      let words = day.textContent.split("/");
      let filteredWords = words.filter((word) => word !== nepaliDay);
      day.textContent =
        filteredWords.join("/") +
        (filteredWords.length > 0 ? "/" : "") +
        nepaliDay;
    });
  };

  //handle Change Functions
  handleDateClick = (arg) => {
    console.log(arg, "arg");
    // this.reRenderDate(100, false);
    // arg is a CalendarDay object with ad.date and bs.date properties
    // Use AD date format for the form inputs
    const dateStr = arg?.ad?.date || arg?.bs?.date || "";
    this.setState(
      {
        action: "add",
        startDate: dateStr,
        endDate: dateStr,
      },
      () => {
        // Open modal after state is updated
        this.setState({ modal: true });
      },
    );
  };

  handleChangeEvent = (e) => {
    const holidaysOptionCopy = [...this.state.holidaysOption];
    let reactSelectEvent = e;
    if (e !== null) {
      this.setState({ selectedEvent: reactSelectEvent });
      var selectedVal = [{ ...e }];
      var selectedColor = selectedVal.map((opt) => opt.color);

      holidaysOptionCopy.forEach((el, id) => {
        if (el.colorCode === selectedColor[0]) {
          this.setState(
            {
              colorCode: el.colorCode,
              isHoliday: el.isHoliday,
              eventType: el.eventTypeName,
            },
            () => {
              this.renderNepaliDates();
            },
          );
        }
      });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "calenderTitle" && value.length > 0) {
      this.setState({ [name]: value });
    }
    name === "calendarTitle" &&
      value.length > 0 &&
      this.setState({ eventNameError: false });

    if (name === "startDate") {
      this.setState({
        endDate: "",
      });
    }

    this.setState({ [name]: value }, () => {
      this.renderNepaliDates();
    });
  };

  handleCalendarChange = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    this.setState({ [name]: value });
    // this.setState({ [name]: value }, this.handleCalendarDate());
  };

  handleEducationLevelChange = (items) => {
    this.setState({ selectedItems: items });
  };

  reRenderDate = (timeOut, loadSpinner) => {
    this.setState({ calendarLoading: loadSpinner });
    const dates = document.querySelectorAll(".fc-day");

    // const currentDate = new Date();
    const currentDate = new Date(this.state?.infoDate?.view.currentStart);

    const currentMonth = currentDate?.getMonth();
    const currentYear = currentDate?.getFullYear();

    dates.forEach((date) => {
      const dateStr = date.getAttribute("data-date");
      const nepalTime = new Date(dateStr);

      const formattedDate = moment(nepalTime).format("YYYY-MM-DD");
      // const nepaliDate = moment(adToBs(formattedDate)).format("DD");
      const nepaliDate = adToBs(formattedDate).split("-")[2];

      // const nepaliDateDevanagari = nepaliDate.replace(/[0-9]/g, (match) => this.devanagariDigits[match]);
      const nepaliDateDevanagari = nepaliDate
        .split("")
        .map((digit) => this.devanagariDigits[digit])
        .join("");

      const newDiv = document.createElement("span");
      newDiv.style.position = "absolute";
      newDiv.style.bottom = "0";
      newDiv.style.marginLeft = "2px";

      if (
        nepalTime?.getMonth() !== currentMonth ||
        nepalTime?.getFullYear() !== currentYear
      ) {
        newDiv.style.opacity = "0.3";
      }

      newDiv.innerText = nepaliDateDevanagari;
      newDiv.style.cssText = `
      position: absolute;
      bottom: 0;
      marginLeft: 5px;
      font-family: 'NepaliFont', Arial;
      opacity: ${
        nepalTime?.getMonth() !== currentMonth ||
        nepalTime?.getFullYear() !== currentYear
          ? "0.3"
          : "1"
      };`;
      date.append(newDiv);
    });

    // // Get the current date
    if (this.state.infoDate != null) {
      const currentDate = moment(
        new Date(this.state?.infoDate?.view.currentStart),
      ).format("YYYY-MM-DD");
      const currentDateEnd = moment(
        new Date(this.state?.infoDate?.view.currentEnd),
      ).format("YYYY-MM-DD");
      const nepaliDate = adToBs(currentDate);
      const nepaliDateEnd = adToBs(currentDateEnd);

      const nepaliMonth =
        this.nepaliMonths[moment(nepaliDate).format("MM") - 1];
      const nepaliMonthEnd =
        this.nepaliMonths[moment(nepaliDateEnd).format("MM") - 1];
      const nepaliMonthYearNp = `(${nepaliMonth}-${nepaliMonthEnd}, ${moment(
        nepaliDate,
      )
        .format("YYYY")
        .replace(/[0-9]/g, (match) => this.devanagariDigits[match])})`;

      // // Append the Nepali month and year to the header title
      const h2Header = document.getElementsByTagName("h2");
      const existingSpan = h2Header[1]?.querySelector("span");

      if (existingSpan) {
        existingSpan.remove();
      }

      const newSpan = document.createElement("span");
      newSpan.innerText = nepaliMonthYearNp;
      if (h2Header[1]) {
        h2Header[1].append(newSpan);
      }
    }

    //  insert day values in nepali
    let days = document.querySelectorAll(
      ".fc-day-header.fc-widget-header.fc-sun, .fc-day-header.fc-widget-header.fc-mon, .fc-day-header.fc-widget-header.fc-tue, .fc-day-header.fc-widget-header.fc-wed, .fc-day-header.fc-widget-header.fc-thu, .fc-day-header.fc-widget-header.fc-fri, .fc-day-header.fc-widget-header.fc-sat",
    );
    let nepaliDays = ["आइत", "सोम", "मंगल", "बुध", "बिही", "शुक्र", "शनि"];
    let secondWeekDays = Array.prototype.slice.call(days, 7);
    secondWeekDays.forEach((day, index) => {
      let nepaliDay = nepaliDays[index % 7];
      let words = day.textContent.split("/");
      let filteredWords = words.filter((word) => word !== nepaliDay);
      day.textContent =
        filteredWords.join("/") +
        (filteredWords.length > 0 ? "/" : "") +
        nepaliDay;
    });
    setTimeout(() => {
      this.setState({ calendarLoading: false });
    }, timeOut);
  };

  handleEventChange = (e) => {
    this.reRenderDate(2000, true);
    // this.setState({ calendarLoading: true })
    const target = e.target;
    const value = target.value;
    const name = target.name;
    if (name === "educationLevelIdMultiple") {
      if (value === "0") {
        let selectedItems = [...this.state.educationLevels];
        selectedItems.forEach((level) => {
          level.label = level.name;
          level.value = level.id;
        });
        this.setState({ selectedItems });
      } else {
        const index = this.state.educationLevels.findIndex(
          (level) => level.id === parseInt(value),
        );
        if (index !== -1) {
          const selectedItems = [];
          selectedItems.push({
            label: this.state.educationLevels[index].name,
            value: this.state.educationLevels[index].id,
          });
          this.setState({ selectedItems });
        }
      }
    }
    this.setState(
      {
        [name]: value,
        termId: "0",
        termTitle: `All ${
          localStorage.getItem("educationLevelDivision")
            ? localStorage.getItem("educationLevelDivision")
            : "Terms"
        }`,
      },
      function () {
        this.handleCalendarEventChange();
      },
    );
  };

  //Function Called when all the events are positisioned on their particular dates

  handleEventPositioned = (arg) => {
    if (arg.event.extendedProps.description) {
      arg.el.setAttribute("data-tip", arg.event.extendedProps.description);
      ReactTooltip.rebuild();
    }
  };

  closeModal = (e) => {
    // this.reRenderDate(100,false);
    this.setState(
      {
        modal: !this.state.modal,
        calendarTitle: "",
        startDate: "",
        endDate: "",
        description: "",
        checked: false,
        selectedEvent: "",
      },
      () => {
        this.renderNepaliDates();
      },
    );
  };

  calendarFooter = () => {
    return (
      <>
        <button
          className="tt-button tt-button-primary"
          type="submit"
          onClick={
            this.state.action === "add"
              ? this.submitCalendar
              : this.updateCalendar
          }
          disabled={this.state.educationLevels.length > 0 ? false : true}
        >
          {this.state.action === "add" ? "Save Event" : "Update Event"}
        </button>
        <button
          type="reset"
          className="tt-button tt-button-primary"
          onClick={
            this.state.action === "add"
              ? this.closeModal
              : () => {
                  displayConfirmDeleteAlert({}, this.deleteEvent);
                }
          }
        >
          {this.state.action === "add" ? "Cancel Event" : "Delete Event"}
        </button>
      </>
    );
  };

  //Submitting Calendar Event Functions

  handleEventForm = () => {
    return (
      <CalendarForm
        selectHolidayOption={this.state.selectHolidayOption}
        create={true}
        calendarTitle={this.state.calendarTitle}
        handleChangeEvent={this.handleChangeEvent}
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        description={this.state.description}
        closeModal={this.closeModal}
        checked={this.state.checked}
        educationLevelId={this.state.educationLevelId}
        educationLevelIdMultiple={this.state.educationLevelIdMultiple}
        educationLevels={this.state.educationLevels}
        handleEducationLevelChange={this.handleEducationLevelChange}
        action={this.state.action}
        showSpinner={this.state.showSpinner}
        eventNameError={this.state.eventNameError}
        handleChange={this.handleChange}
        selectedEvent={this.state.selectedEvent}
        isHoliday={this.state.isHoliday}
        colorCode={this.state.colorCode}
        maxEndDate={this.state.currentAcYr.endDate}
      ></CalendarForm>
    );
  };

  submitCalendar = (e) => {
    e.preventDefault();
    if (
      this.state.calendarTitle === "" ||
      this.state.startDate === "" ||
      this.state.endDate === "" ||
      this.state.isHoliday === "" ||
      this.state.colorCode === ""
    ) {
      swal({
        title: "Oops",
        text: "Fill all the necessary fields: Event Name, Start Date and End Date ,Event Type.",
        allowOutsideClick: false,
        closeOnClickOutside: false,
      });
      return false;
    }
    let datas = [];
    let color = this.state.colorCode;
    let isHoliday = this.state.isHoliday;
    let eventTypeName = this.state.eventType;
    datas = this.getData(
      color,
      isHoliday,
      eventTypeName,
      this.state.educationLevelId,
    );

    this.setState({ showSpinner: true }, function () {
      axiosPost(
        URL.insertEvent,
        datas,
        (response) => {
          if (response.status === 200) {
            displayMessage("Success", "Events added successfully.", () => {
              this.getWidgetEvents();
              this.props.getCalendarEvents(
                this.props.assessmentModuleandEducationLevel,
              );
            });
            this.setState(
              {
                modal: !this.state.modal,
                calendarTitle: "",
                startDate: "",
                endDate: "",
                description: "",
                holidayChecked: false,
                educationLevelId: 0,
                showSpinner: false,
                eventNameError: false,
                selectedEvent: "",
                colorCode: "",
              },
              () => {
                this.renderNepaliDates();
              },
            );
          }
        },
        (error) => {
          this.setState({ showSpinner: false });
          displayErrorAlert(error);
        },
      );
    });
  };

  //Updating Calendar Functions
  handleEventClick = (arg) => {
    console.log("arg", arg);

    if (arg?.schoolId) {
      let holidayOptionCopy = [...this.state.holidaysOption];
      let colorCode;
      holidayOptionCopy.forEach((el) => {
        if (el.eventTypeName === arg.eventTypeName) {
          colorCode = el.colorCode;
        }
      });

      let selectedOptionAfterUpdate = {};
      Object.assign(selectedOptionAfterUpdate, {
        color: colorCode,
        label: arg.eventTypeName,
        value: colorCode,
      });
      let title = arg.title;
      let start = moment(arg.start).format("YYYY-MM-DD");
      //Uncommented
      let end = moment(arg.end).format("YYYY-MM-DD");

      if (end === "Invalid date") {
        end = start;
      }
      //
      let checked;
      if (arg.backgroundColor === "#a70707") {
        checked = true;
      } else {
        checked = false;
      }
      let description = arg.description;
      let educationLevelId = arg.educationLevelId;
      let eventTypeName = selectedOptionAfterUpdate;

      let id = arg.id;

      this.setState(
        {
          action: "edit",
          calendarTitle: title,
          startDate: start,
          endDate: end !== "Invalid date" ? end : start, //Uncommented
          description: description,
          updateId: id,
          eventInfo: arg,
          checked: checked,
          educationLevelId: educationLevelId,
          selectedEvent: eventTypeName,
          colorCode: selectedOptionAfterUpdate.color,
        },
        function () {
          this.setState({ modal: !this.state.modal });
        },
      );
    }
    // commented this block as currently clicking on subday throws the error as calendar package takes the sunday as holiday event thus throwing an error in swal
    // else {
    //   swal("Information", "This calendar event cannot be changed.");
    // }
  };

  updateEventForm = () => {
    return (
      <CalendarForm
        create={false}
        submit={this.updateCalendar}
        closeModal={this.closeModal}
        checked={this.state.checked}
        calendarTitle={this.state.calendarTitle}
        handleChangeEvent={this.handleChangeEvent}
        handleChange={this.handleChange}
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        description={this.state.description}
        educationLevels={this.state.educationLevels}
        educationLevelIdMultiple={this.state.educationLevelIdMultiple}
        handleEducationLevelChange={this.handleEducationLevelChange}
        action={this.state.action}
        showSpinner={this.state.showSpinner}
        selectHolidayOption={this.state.selectHolidayOption}
        selectedEvent={this.state.selectedEvent}
        colorCode={this.state.colorCode}
        isHoliday={this.state.isHoliday}
        maxEndDate={this.state.currentAcYr.endDate}
      ></CalendarForm>
    );
  };

  updateCalendar = (e) => {
    e.preventDefault();

    if (
      this.state.calendarTitle === "" ||
      this.state.startDate === "" ||
      this.state.endDate === ""
    ) {
      swal({
        title: "Oops",
        text: "Fill all the necessary fields: Event Name, Start Date and End Date ,Event Type.",
        allowOutsideClick: false,
        closeOnClickOutside: false,
      });
      return false;
    }

    let chkID = parseInt(this.state.updateId);
    const events = [...this.state.unfilteredEvents];
    const groupedEvents = {};

    events.forEach((event) => {
      const key = `${event.color}-${event.title}`;

      if (!groupedEvents[key]) {
        groupedEvents[key] = [];
      }

      groupedEvents[key].push(event);
    });

    const unique = Object.values(groupedEvents);

    let sameEvents = [];

    unique.forEach((u) => {
      if (u.find((iu) => iu.id === chkID)) {
        sameEvents.push(u);
      }
    });

    let updateIds = [];
    if (this.state.educationLevelIdMultiple === "0") {
      updateIds = sameEvents[0].map((el) => {
        return el.id;
      });
    } else {
      updateIds = sameEvents[0].map((el) => {
        if (el.educationLevelId == this.state.educationLevelIdMultiple) {
          return el.id;
        }
      });
    }

    let newUpdateIds = updateIds.filter((elements) => {
      return elements != null && elements !== undefined && elements !== "";
    });

    // const chkID = parseInt(this.state.updateId);
    // const events = [...this.state.unfilteredEvents];

    // const sameEvents = events.filter((event, index, arr) => {
    //   const key = `${event.color}-${event.title}`;
    //   return (
    //     arr.findIndex((e) => `${e.color}-${e.title}` === key) === index &&
    //     event.id === chkID
    //   );
    // });

    // const eventIds = sameEvents.map((event) => event.id);

    let color = this.state.colorCode;
    let isHoliday = this.state.isHoliday;
    let eventTypeName = this.state.eventType;
    let datas = this.getData(
      color,
      isHoliday,
      eventTypeName,
      this.state.educationLevelId,
    );
    datas.ids = newUpdateIds;
    this.setState({ showSpinner: true }, function () {
      axiosPost(
        URL.updateEvent,
        datas,
        (response) => {
          if (response.status === 200) {
            swal({
              title: "Success",
              text: "Events updated successfully",
              allowOutsideClick: false,
              closeOnClickOutside: false,
            });
            draggable();
            this.props.getCalendarEvents(
              this.props.assessmentModuleandEducationLevel,
            );
            this.getWidgetEvents();
            this.setState(
              {
                modal: !this.state.modal,
                calendarTitle: "",
                startDate: "",
                endDate: "",
                description: "",
                updateId: "",
                checked: false,
                educationLevelId: 0,
                showSpinner: false,

                color: "",
                selectedEvent: "",
              },
              function () {
                ReactTooltip.rebuild();
              },
            );
            this.handleCalendarEventChange();
          }
        },
        (error) => {
          this.setState({ showSpinner: false });
          let errorResponse = error.response ? error.response.data : error;
          if (errorResponse.status === 400) {
            //if condition to check spring boot validation errors
            let errorMessage = "";
            if (errorResponse.errors) {
              errorResponse.errors.forEach((error) => {
                errorMessage += `${error.field
                  .replace(/([A-Z])/g, " $1")
                  .replace(/^./, function (str) {
                    return str.toUpperCase();
                  })} ${error.defaultMessage} \n`; //ishan
              });
              swal(errorResponse.error, errorMessage, "");
            } else {
              swal(errorResponse.error, errorResponse.message, "");
            }
          } else {
            swal(
              errorResponse.error || "Network Error",
              errorResponse.message
                ? errorResponse.message
                : "Could Not Connect To The Server.",
              "",
            );
          }
        },
      );
    });
  };

  //Deleting Calendar Events
  deleteEvent = () => {
    let id = parseInt(this.state.updateId);

    // let newEl = [];

    // if (this.state.educationLevelIdMultiple === "0") {
    //   newEl = this.state.educationLevels.map((el) => {
    //     return el.id;
    //   });
    // } else {
    //   newEl.push(this.state.educationLevelIdMultiple);
    // }

    let chkID = parseInt(this.state.updateId);
    const events = [...this.state.unfilteredEvents];
    const groupedEvents = {};

    events.forEach((event) => {
      const key = `${event.color}-${event.title}`;

      if (!groupedEvents[key]) {
        groupedEvents[key] = [];
      }

      groupedEvents[key].push(event);
    });

    const unique = Object.values(groupedEvents);

    let sameEvents = [];

    unique.forEach((u) => {
      if (u.find((iu) => iu.id === chkID)) {
        sameEvents.push(u);
      }
    });

    let updateIds = [];

    if (this.state.educationLevelIdMultiple === "0") {
      updateIds = sameEvents[0].map((el) => {
        return el.id;
      });
    } else {
      updateIds = sameEvents[0].map((el) => {
        if (el.educationLevelId == this.state.educationLevelIdMultiple) {
          return el.id;
        }
      });
    }

    var res = updateIds.filter((elements) => {
      return elements != null && elements !== undefined && elements !== "";
    });

    let param = {
      ids: res,
      // educationLevelIds: newEl,
    };

    axiosPost(URL.deleteEvent, param, (response) => {
      if (response.status === 200) {
        swal({
          title: "Success",
          text: "Records deleted successfully",
          allowOutsideClick: false,
          closeOnClickOutside: false,
        });
        draggable();
        this.setState(
          {
            modal: !this.state.modal,
            educationLevelId: "0",
            events: [],
            calendarTitle: "",
            startDate: "",
            endDate: "",
            description: "",
            holidayChecked: false,
          },
          () => {
            this.getWidgetEvents();
            this.props.getCalendarEvents(
              this.props.assessmentModuleandEducationLevel,
            );
          },
        );
      }
    });
  };

  //Render Past Calendar
  gotoPast = () => {
    if (this.state.year.length === 4) {
      this.setState({ error: "" });
      let date = this.state.year + "-01-01";
      let calendarApi = this.calendarComponentRef.current.getApi();
      calendarApi.gotoDate(date); // call a method on the Calendar object
    } else {
      this.setState({ error: "Enter a valid year" });
    }
  };

  //Multiple Calendar
  handleCalendarDate = () => {
    this.setState({ dates: [] }, function () {
      if (this.state.termId === "0") {
        // this.getAllDates();
        // this.getAcYrDate();
        this.setState({
          termTitle: `All ${
            localStorage.getItem("educationLevelDivision")
              ? localStorage.getItem("educationLevelDivision")
              : "Terms"
          }`,
        });
      } else {
        let data = {
          id: this.state.termId,
        };
        axiosPost(URL.getEducationLevelDivisionByKey, data, (response) => {
          if (response.status === 200) {
            this.setState({ calendarDates: response.data.data }, function () {
              let startDates = moment(
                this.state.calendarDates.startDate,
              ).format("YYYY-MM-DD");
              let x = startDates.split("-");
              let endDates = moment(this.state.calendarDates.endDate).format(
                "YYYY-MM-DD",
              );
              let y = endDates.split("-");
              let newDates = [...this.state.dates];
              if (
                parseInt(x[0]) < parseInt(y[0]) ||
                parseInt(x[0]) === parseInt(y[0])
              ) {
                if (parseInt(x[0]) === parseInt(y[0])) {
                  if (
                    parseInt(x[1]) < parseInt(y[1]) ||
                    parseInt(x[1]) === parseInt(y[1])
                  ) {
                    for (let i = parseInt(x[1]); i <= parseInt(y[1]); i++) {
                      if (i < 10) {
                        newDates.push(x[0] + "-0" + i.toString() + "-01");
                      } else {
                        newDates.push(x[0] + "-" + i.toString() + "-01");
                      }
                    }
                  }
                } else {
                  for (let i = parseInt(x[0]); i <= parseInt(y[0]); i++) {
                    let mx, my;
                    if (i === parseInt(x[0])) {
                      mx = parseInt(x[1]);
                      my = 12;
                    } else if (i === parseInt(y[0])) {
                      mx = 1;
                      my = parseInt(y[1]);
                    } else {
                      mx = 1;
                      my = 12;
                    }
                    for (let j = mx; j <= my; j++) {
                      if (j < 10) {
                        newDates.push(
                          i.toString() + "-0" + j.toString() + "-01",
                        );
                      } else {
                        newDates.push(
                          i.toString() + "-" + j.toString() + "-01",
                        );
                      }
                    }
                  }
                }
              }
              this.setState({
                dates: newDates,
                termTitle: this.state.calendarDates.name,
              });
              ReactTooltip.rebuild();
            });
          }
        });
      }
    });
  };

  // getAcYrDate = () => {
  //   let startDates = moment(this.state.currentAcYr.startDate).format(
  //     "YYYY-MM-DD"
  //   );
  //   let x = startDates.split("-");
  //   let endDates = moment(this.state.currentAcYr.endDate).format("YYYY-MM-DD");
  //   let y = endDates.split("-");
  //   let newDates = [...this.state.dates];
  //   if (parseInt(x[0]) < parseInt(y[0]) || parseInt(x[0]) === parseInt(y[0])) {
  //     if (parseInt(x[0]) === parseInt(y[0])) {
  //       if (
  //         parseInt(x[1]) < parseInt(y[1]) ||
  //         parseInt(x[1]) === parseInt(y[1])
  //       ) {
  //         for (let i = parseInt(x[1]); i <= parseInt(y[1]); i++) {
  //           if (i < 10) {
  //             newDates.push(x[0] + "-0" + i.toString() + "-01");
  //           } else {
  //             newDates.push(x[0] + "-" + i.toString() + "-01");
  //           }
  //         }
  //       }
  //     } else {
  //       for (let i = parseInt(x[0]); i <= parseInt(y[0]); i++) {
  //         let mx, my;
  //         if (i === parseInt(x[0])) {
  //           mx = parseInt(x[1]);
  //           my = 12;
  //         } else if (i === parseInt(y[0])) {
  //           mx = 1;
  //           my = parseInt(y[1]);
  //         } else {
  //           mx = 1;
  //           my = 12;
  //         }
  //         for (let j = mx; j <= my; j++) {
  //           if (j < 10) {
  //             newDates.push(i.toString() + "-0" + j.toString() + "-01");
  //           } else {
  //             newDates.push(i.toString() + "-" + j.toString() + "-01");
  //           }
  //         }
  //       }
  //     }
  //   }
  //   this.setState({
  //     dates: newDates,
  //   });
  //   ReactTooltip.rebuild();
  // };

  handleCalendarEventChange = () => {
    // this.getEvents(this.state.educationLevelIdMultiple);
    if (this.state.educationLevelIdMultiple === "0") {
      this.setState({ eduLevelTitle: "All", terms: [] });
      this.getWidgetEvents();
    } else {
      axiosPost(
        URL.getEducationLevelByKey,
        {
          id: this.state.educationLevelIdMultiple,
        },
        (response) => {
          if (response.status === 200) {
            this.setState({ eduLevelTitle: response.data.data.name });
          }
        },
      );
      this.setState({ widgetEvents: [] }, () => {
        axiosPost(
          URL.getEventsByEducationLevel,
          { educationLevelId: this.state.educationLevelIdMultiple },
          (responseWidgets) => {
            if (responseWidgets.status === 200) {
              axiosPost(
                URL.getWeekDaysByEduDiv,
                { educationLevelId: this.state.educationLevelIdMultiple },
                (response) => {
                  if (response.status === 200) {
                    const weekDays = [0, 1, 2, 3, 4, 5, 6];
                    const days = response.data.data.map(({ id }) => id);
                    let filteredDays = weekDays.filter(
                      (el) => !days.includes(el),
                    );
                    let anEvent = [];
                    anEvent.push({
                      daysOfWeek: filteredDays,
                      rendering: "background",
                      color: `#668ef5`,
                      overLap: false,
                      allDay: true,
                    });
                    let newEvents = [...responseWidgets.data.data];
                    newEvents.forEach((event) => {
                      event.end = moment(event.end).format("YYYY-MM-DD");
                      event.start = moment(event.start).format("YYYY-MM-DD");
                    });
                    this.setState(
                      {
                        widgetEvents: [...anEvent, ...newEvents],
                      },

                      () => {
                        const events = [...this.state.widgetEvents];
                        const unique = [];
                        events.map((x) =>
                          unique.filter(
                            (a) =>
                              a.color == x.color &&
                              a.title == x.title &&
                              a.start == x.start &&
                              a.end == x.end,
                          ).length > 0
                            ? null
                            : unique.push(x),
                        );
                        this.setState({ uniqueCalendarEvents: unique });
                      },
                    );
                  }
                },
              );
              //   this.setState({ widgetEvents: response.data.data });
            }
          },
        );
      });
      // let data = {
      //   educationLevelId: parseInt(this.state.educationLevelIdMultiple),
      // };
      // axiosPost(
      //   URL.getEducationLevelDivisionsByEducationLevelId,
      //   data,
      //   (response) => {
      //     if (response.status === 200) {
      //       this.setState({ terms: response.data.data });
      //     }
      //   }
      // );
    }
  };

  calendarGetDate = (idx) => {
    let date;
    let year = new Date().getFullYear();

    if (this.state.termId === "0") {
      date = year + "-" + this.state.dates[idx] + "-01";
    } else {
      date = this.state.dates[idx];
    }
    return date;
  };

  // openDate = (e, idx) => {
  //   e.preventDefault();
  //   let calendarApi = this.calendarComponentRef.current.getApi();
  //   let date;
  //   date = this.state.dates[idx];
  //   calendarApi.gotoDate(date);
  //   ReactTooltip.rebuild();
  // };

  checkForAdministratorRole = () => {
    let canInsert = false;
    if (userRole === userRoleCode.roleStaff) {
      if (this.state.educationLevelIdMultiple === "0") {
        canInsert = false;
      } else {
        const educationLevelIndex = this.state.educationLevels.findIndex(
          (level) => level.id === parseInt(this.state.educationLevelIdMultiple),
        );
        if (educationLevelIndex !== -1) {
          const assessmentModuleCode =
            this.state.educationLevels[educationLevelIndex]
              .assessmentModuleCode;
          this.state.assessmentModules.forEach((assessmentModule) => {
            if (
              assessmentModuleCode === assessmentModule.code &&
              checkForSubRoles(`${assessmentModule.code}_ADMTR`)
            )
              canInsert = true;
          });
        }
      }
    }
    return canInsert;
  };

  renderNepaliDate = (date) => {
    const nepaliDate = adToBs(moment(date).format("YYYY-MM-DD"));
    return nepaliDate.format("DD");
  };

  eventRender = (info) => {
    const nepaliDate = this.renderNepaliDate(info.event.start);
    info.el.innerHTML = `
      <div>
        <span>${info.event.title}</span>
        <br />
        <span>${nepaliDate}</span>
      </div>
    `;
  };

  devanagariDigits = {
    0: "०",
    1: "१",
    2: "२",
    3: "३",
    4: "४",
    5: "५",
    6: "६",
    7: "७",
    8: "८",
    9: "९",
  };

  nepaliMonths = [
    "बैशाख", // April-May
    "जेष्ठ", // May-June
    "असार", // June-July
    "श्रावण", // July-August
    "भाद्र", // August-September
    "आश्विन", // September-October
    "कार्तिक", // October-November
    "मंसिर", // November-December
    "पौष", // December-January
    "माघ", // January-February
    "फाल्गुन", // February-March
    "चैत्र", // March-April
  ];

  handleChangeCalendarToggle = (e) => {
    const { name, checked } = e.target;
    if (checked) {
      this.setState({
        bsCalendar: true,
        adCalendar: false,
      });
    } else {
      this.setState({
        adCalendar: true,
        bsCalendar: false,
      });
    }
  };

  render() {
    return (
      <div className="tt-widgetContent-tab-holder" style={{ height: "79.5vh" }}>
        {/* {console.log(this.props.assessmentModuleandEducationLevel)} */}
        <CalendarWidgetHeader
          educationLevelIdMultiple={this.state.educationLevelIdMultiple}
          handleCalendarChange={this.handleCalendarChange}
          educationLevels={this.state.educationLevels}
          handleEventChange={this.handleEventChange}
          getCalendarEvents={this.getWidgetEvents}
          terms={this.state.terms}
          termId={this.state.termId}
          eduLevelTitle={this.state.eduLevelTitle}
          termTitle={this.state.termTitle}
          assessmentModules={this.state.assessmentModules}
        ></CalendarWidgetHeader>
        {/* added a toggle for calendar type switch */}
        {/* <div className="d-flex align-items-center justify-content-end mr-2 mb-2">
          <div className="d-flex align-items-center">
            <p className="m-0 mr-2">A.D.</p>
            <label class="switch">
              <input
                type="checkbox"
                onChange={(e) => this.handleChangeCalendarToggle(e)}
                checked={this.state.bsCalendar}
              />
              <span class="slider round"></span>
            </label>
            <p class="m-0 ml-2">B.S.</p>
          </div>
        </div> */}

        <div className="container-fluid">
          {this.state.calendarLoading ? (
            <>
              <div className="row">
                <div className="col" style={{ height: "65vh" }}>
                  <div className="d-flex align-items-center justify-content-center flex-column">
                    <Spinner color="primary"></Spinner>
                    <p className="mt-1">Loading Calendar...</p>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row">
                <div className="col-md-1"></div>
                <div
                  className="col tt-adjustPadding tt-widgetContent-tab-holder"
                  style={{ height: "auto" }}
                >
                  {console.log(this.state.uniqueCalendarEvents)}
                  <NepaliCalendar
                    date={this.state.currentAcYr.startDate}
                    endDate={this.state.currentAcYr.endDate}
                    onChange={(date) => this.handleCalendarChange(date)}
                    calendarMode={localStorage.getItem("calendar-mode")}
                    showToggle={true}
                    showNationalHoliday={true}
                    events={this.state.uniqueCalendarEvents || []}
                    onDateSelect={this.handleDateClick}
                    onEventClick={this.handleEventClick}
                    showNationalHolidayToggle={true}
                  />
                  {/* {this.state.adCalendar ? (
                    <>
                      <FullCalendar
                        dateClick={
                          checkRolePermissions(
                            "insert-calendar-event",
                            "activity"
                          ) || this.checkForAdministratorRole()
                            ? this.handleDateClick
                            : null
                        }
                        ref={this.calendarComponentRef}
                        eventLimit={3}
                        header={{
                          left: "prev",
                          center: "title",
                          right: "next",
                        }}
                        defaultView="dayGridMonth"
                        plugins={[
                          dayGridPlugin,
                          timeGridPlugin,
                          interactionPlugin,
                        ]}
                        weekends={true}
                        fullDay={true}
                        displayEventTime={false}
                        events={this.state.uniqueCalendarEvents || []}
                        eventPositioned={this.handleEventPositioned}
                        eventClick={this.handleEventClick}
                        // eventRender={this.eventRender}
                        validRange={{
                          start: this.state.currentAcYr.startDate,
                          end: this.state.currentAcYr.endDate,
                        }}
                        datesRender={(info) => {
                          window.setTimeout(() => {
                            this.renderNepaliDates();
                            this.setState({ infoDate: info });
                            const dates = document.querySelectorAll(".fc-day");

                            // const currentNpDate = new Date();
                            const currentNpDate = new Date(
                              this.state?.infoDate?.view.currentStart
                            );

                            const currentMonth = currentNpDate?.getMonth();
                            const currentYear = currentNpDate?.getFullYear();

                            dates.forEach((date) => {
                              const dateStr = date.getAttribute("data-date");
                              const nepalTime = new Date(dateStr);

                              const formattedDate =
                                moment(nepalTime).format("YYYY-MM-DD");
                              // const nepaliDate = moment(adToBs(formattedDate)).format("DD");
                              const nepaliDate =
                                adToBs(formattedDate).split("-")[2];

                              // const nepaliDateDevanagari = nepaliDate.replace(/[0-9]/g, (match) => this.devanagariDigits[match]);
                              const nepaliDateDevanagari = nepaliDate
                                .split("")
                                .map((digit) => this.devanagariDigits[digit])
                                .join("");

                              const existingDiv = date.querySelector("span");
                              if (existingDiv) {
                                existingDiv.remove();
                              }

                              const newDiv = document.createElement("span");
                              newDiv.style.position = "absolute";
                              newDiv.style.bottom = "0";
                              newDiv.style.marginLeft = "2px";

                              if (
                                nepalTime?.getMonth() !== currentMonth ||
                                nepalTime?.getFullYear() !== currentYear
                              ) {
                                newDiv.style.opacity = "0.3";
                              }

                              newDiv.innerText = nepaliDateDevanagari;
                              newDiv.style.cssText = `
                                      position: absolute;
                                      bottom: 0;
                                      marginLeft: 5px;
                                      font-family: 'NepaliFont', Arial;
                                      opacity: ${
                                        nepalTime?.getMonth() !==
                                          currentMonth ||
                                        nepalTime?.getFullYear() !== currentYear
                                          ? "0.3"
                                          : "1"
                                      };`;
                              date.append(newDiv);
                            });

                            // Get the current date
                            const currentDate = moment(
                              new Date(info.view.currentStart)
                            ).format("YYYY-MM-DD");
                            const currentDateEnd = moment(
                              new Date(info.view.currentEnd)
                            ).format("YYYY-MM-DD");
                            const nepaliDateHeader = adToBs(currentDate);
                            const nepaliDateHeaderNextYear =
                              parseInt(
                                moment(nepaliDateHeader).format("YYYY")
                              ) + 1;
                            const nepaliDateEndHeader = adToBs(currentDateEnd);
                            const nepaliMonthHeader =
                              this.nepaliMonths[
                                moment(nepaliDateHeader).format("MM") - 1
                              ];
                            // const nepaliMonthHeader = this.nepaliMonths[nepaliDateHeader?.getMonth()];
                            const nepaliMonthEndHeader =
                              this.nepaliMonths[
                                moment(nepaliDateEndHeader).format("MM") - 1
                              ];
                            // const nepaliMonthEndHeader = this.nepaliMonths[nepaliDateEndHeader?.getMonth()];

                            const nepaliMonthYearNpHeader =
                              nepaliMonthEndHeader === "बैशाख" &&
                              nepaliMonthHeader === "चैत्र"
                                ? `(${nepaliMonthHeader}-${nepaliMonthEndHeader}, ${moment(
                                    nepaliDateHeader
                                  )
                                    .format("YYYY")
                                    .replace(
                                      /[0-9]/g,
                                      (match) => this.devanagariDigits[match]
                                    )} / ${nepaliDateHeaderNextYear
                                    .toString()
                                    .replace(
                                      /[0-9]/g,
                                      (match) => this.devanagariDigits[match]
                                    )})
                              `
                                : `(${nepaliMonthHeader}-${nepaliMonthEndHeader}, ${moment(
                                    nepaliDateHeader
                                  )
                                    .format("YYYY")
                                    .replace(
                                      /[0-9]/g,
                                      (match) => this.devanagariDigits[match]
                                    )})`;

                            // Append the Nepali month and year to the header title
                            const h2Header =
                              document.getElementsByTagName("h2");

                            const existingSpan =
                              h2Header[1]?.querySelector("span");

                            if (existingSpan) {
                              existingSpan.remove();
                            }
                            const newSpan = document.createElement("span");
                            newSpan.innerText = nepaliMonthYearNpHeader;
                            if (h2Header[1]) {
                              h2Header[1].append(newSpan);
                            }

                            let days = document.querySelectorAll(
                              ".fc-day-header.fc-widget-header.fc-sun, .fc-day-header.fc-widget-header.fc-mon, .fc-day-header.fc-widget-header.fc-tue, .fc-day-header.fc-widget-header.fc-wed, .fc-day-header.fc-widget-header.fc-thu, .fc-day-header.fc-widget-header.fc-fri, .fc-day-header.fc-widget-header.fc-sat"
                            );
                            let nepaliDays = [
                              "आइत",
                              "सोम",
                              "मंगल",
                              "बुध",
                              "बिही",
                              "शुक्र",
                              "शनि",
                            ];
                            let secondWeekDays = Array.prototype.slice.call(
                              days,
                              7
                            );
                            secondWeekDays.forEach((day, index) => {
                              let nepaliDay = nepaliDays[index % 7];
                              let words = day.textContent.split("/");
                              let filteredWords = words.filter(
                                (word) => word !== nepaliDay
                              );
                              day.textContent =
                                filteredWords.join("/") +
                                (filteredWords.length > 0 ? "/" : "") +
                                nepaliDay;
                            });
                          }, 100);
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <NewNepaliCalendar
                        assessmentModuleandEducationLevel={
                          this.props.assessmentModuleandEducationLevel
                        }
                      />
                    </>
                  )} */}
                </div>
                <div className="col-md-1"></div>

                {/* <div className="col-md-6 tt-adjustPadding">
              <div className="tt-displayDate">
                {this.state.dates.map((date, idx) => {
                  return (
                    <div
                      className="tt-calendarHolder tt-widgetContent-tab-holder"
                      onClick={(e) => this.openDate(e, idx)}
                      key={idx}
                    >
                      <FullCalendar
                        defaultDate={date}
                        header={{ left: "", center: "title", right: "" }}
                        defaultView="dayGridMonth"
                        plugins={[dayGridPlugin]}
                        weekends={true}
                        columnHeader={false}
                      />
                    </div>
                  );
                })}
              </div>
            
            </div> */}
              </div>
            </>
          )}
        </div>

        <ModalWindow
          fullWidth={false}
          modal={this.state.modal}
          toggleModal={this.closeModal}
          modalHeader={
            this.state.action === "add"
              ? "Set Calendar Events"
              : "Update Calendar Events"
          }
          modalBody={
            this.state.action === "add"
              ? this.handleEventForm()
              : this.updateEventForm()
          }
          modalFooter={this.calendarFooter()}
        ></ModalWindow>
        <ReactTooltip globalEventOff="click"></ReactTooltip>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  calendarEvents: state.academicAdministration.calendarEvents,
});
const mapActionToProps = {
  getCalendarEvents,
};
export default connect(mapStateToProps, mapActionToProps)(CalendarWidget);
